import React from "react";
import { FaLeaf, FaSeedling, FaFire, FaShieldAlt, FaTruck } from "react-icons/fa";

const items = [
  { icon: FaLeaf, title: "Women Empowered", text: "Supporting women farmers" },
  { icon: FaSeedling, title: "Single Origin", text: "Rulindo · Kamonyi · Karongi" },
  { icon: FaFire, title: "Freshly Roasted", text: "Small batches weekly" },
  { icon: FaShieldAlt, title: "Secure Checkout", text: "Safe & trusted payments" },
  { icon: FaTruck, title: "Fast Delivery", text: "Across Rwanda & beyond" },
];

const ValueBar = () => {
  return (
    <section className="bg-espresso text-cream">
      <div className="mx-auto flex max-w-7xl gap-4 overflow-x-auto px-4 py-5 scrollbar-hide sm:grid sm:grid-cols-2 sm:overflow-visible sm:px-5 sm:py-0 sm:divide-y-0 md:px-6 lg:grid-cols-5">
        {items.map(({ icon: Icon, title, text }, i) => (
          <div
            key={title}
            className={`flex min-w-[14rem] shrink-0 items-start gap-3 rounded-xl border border-cream/10 bg-espresso-soft/40 px-4 py-4 sm:min-w-0 sm:rounded-none sm:border-0 sm:bg-transparent sm:px-5 sm:py-7 md:px-6 ${
              i < items.length - 1 ? "lg:border-r lg:border-cream/10" : ""
            }`}
          >
            <Icon className="mt-0.5 shrink-0 text-gold" size={18} />
            <div>
              <h3 className="text-sm font-semibold tracking-wide">{title}</h3>
              <p className="mt-1 text-xs leading-snug text-cream/65">{text}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ValueBar;
